<script>
import { mapGetters } from 'vuex'
export default {
    name: 'DeliveryInfo',

    props: {
        model: {
            type: Object,
            default: () => {},
        },
        canteen: {
            type: String,
            default: undefined,
        },
    },

    computed: {
        ...mapGetters({
            locale: 'locale',
            isAsap: 'order/asap',
            deliveryTime: 'order/time"',
            address: 'order/address',
        }),
        deliveryDate() {
            return this.model?.delivery?.delivery_date
        },
        delay() {
            return this.model?.delivery?.delivery_delay
        },
        warning() {
            return !this.model.is_open
        },
        canteenClosed() {
            return this.canteen ? this.$moment().isAfter(this.canteen, 'minute') : null
        },
        canteenOrderRanOut() {
            return this.canteen && this.model.remaining_order_count >= 0
                ? this.model.remaining_order_count === 0
                : null
        },
        leftToOrder() {
            if (!this.canteen) return null
            const hours = this.$moment(this.canteen).diff(this.$moment(), 'hours')
            if (hours > 24) {
                const days = this.$moment(this.canteen).diff(this.$moment(), 'days')
                return this.$t('canteen.banner.days', { count: days }, days)
            } else if (hours < 1) {
                const minutes = this.$moment(this.canteen).diff(this.$moment(), 'minutes')
                return this.$t('canteen.banner.minutes', { count: minutes }, minutes)
            } else return this.$t('canteen.banner.hours', { count: hours }, hours)
        },
        formattedDeliveryInfo() {
            let deliveryInfo
            if (!this.deliveryDate) return undefined
            const { min, max } = this.deliveryDate
            switch (this.deliveryDate.type) {
                case 'min':
                    if (min === max) {
                        if (min === '0') break
                        deliveryInfo = min
                    } else deliveryInfo = `${min}-${max}`
                    deliveryInfo = `${deliveryInfo} ${this.$t('restaurant.minute')}`
                    break
                case 'hour':
                    // API already formats these as HH:mm – print them as they are
                    if (this.isNonEmptyString(min) && this.isNonEmptyString(max))
                        deliveryInfo = `${this.$t('base.today')} ${min} - ${max}`
                    else if (this.isNonEmptyString(max))
                        deliveryInfo = `${this.$t('base.today')} ${max}`
                    break
                case 'date':
                    deliveryInfo = this.$options.filters.toDeliveryDateRange(min, max)
                    // defensive fallback to the old single-value badge when only the end is usable
                    if (!deliveryInfo && this.isNonEmptyString(max) && this.$moment(max).isValid())
                        deliveryInfo = this.$options.filters.toDeliveryDate(max)
            }
            return deliveryInfo || undefined
        },
    },

    methods: {
        isNonEmptyString(value) {
            return typeof value === 'string' && value.trim() !== ''
        },
    },
}
</script>

<template lang="pug">
span.delivery-info.badge.badge-pill.badge-light.text-m(v-if="canteen && !canteenClosed && !canteenOrderRanOut")
    span.text-primary.font-weight-semibold.mr-2 {{leftToOrder}}
    span.text-73 {{$t('canteen.banner.left_to_order')}}
span.delivery-info.badge.badge-pill.badge-light.text-m(v-else-if="formattedDeliveryInfo && !canteen")
    span.font-weight-semibold.text-m.badge-text(:class="{'text-warning': warning}") {{ formattedDeliveryInfo }}
    template(v-if="delay > 0 && isAsap")
        | &nbsp;
        icon.text-warning.mr-1(icon="fa-solid fa-exclamation-triangle" v-if='delay > 0 && isAsap')
        span.font-weight-semibold.text-m.badge-text +{{ delay }} {{ $t('restaurant.minute') }} {{ $t('restaurant.delay') }}
</template>
